import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { FormGroup, FormControl, FormLabel, FormCheck, Row, Col } from "react-bootstrap";
import moment from "moment";
import { getFirstLastInterval } from "utils/datetime";
import { FiX } from "react-icons/fi";
import TimeInputWithArrows from "components/TimeInputWithArrows";
import { rulesService } from "services";
import { errorFormating, normalizeDecimal } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as rulesActions from 'actions/rulesActions';
import { withTranslation } from 'react-i18next';
import * as ubicationsActions from 'actions/ubicationsActions';
import * as calendarsActions from 'actions/calendarsActions';
import { convertToUTC } from 'utils/datetime';
import {
	isShiftRuleType,
	isTimeTypeRuleType,
	isClockedHoursRuleType,
	isCalculatedRuleType,
	supportsDayTypeFilter,
	isContractRuleType,
} from 'components/Rules/utils';

class RuleEdit extends React.Component {

	constructor(props) {
		super(props);
		// console.log(props);

		let rule = {
			name: '',
			description: '',
			formula_pretty: '',
			formula_easy: '',
			is_add: true,
			accounts_in_formula: [],
			start_hour: '',
			end_hour: '',
			// Coeficiente (valor) para reglas simples (ej. turno).
			// Se mostrará con coma en el UI y se enviará como string con punto en "formula".
			coefficient: '1',
		}

		let isEdit = false;
		let isReadOnly = false;
		var selected_contracts = [];

		if (props.rule) {
			isEdit = true;
			rule = props.rule;

			isReadOnly = (rule.system) ? true : false

			if (rule.account)
				rule.account_id = rule.account.id;

			if (rule.shift)
				rule.shift_id = rule.shift.id;

			if (rule.time_type)
				rule.time_type_id = rule.time_type.id;

			if (rule.ubication)
				rule.ubication_id = rule.ubication.id;

			// El backend puede devolver day_type (objeto) o day_type_id (ID directo)
			// Siguiendo el patrón: ubication_id, account_id, etc. Usamos snake_case: day_type_id
			// NOTA: Si el backend no devuelve este campo en el GET, no se mostrará al editar.
			// El backend debe incluir day_type o day_type_id en la respuesta GET para que funcione correctamente.
			if (rule.day_type) {
				// Si viene como objeto completo (preferido)
				rule.day_type_id = rule.day_type.id;
			} else if (rule.day_type_id) {
				// Si viene como ID directo, mantenerlo
				rule.day_type_id = rule.day_type_id;
			}
			// Si no viene ninguno, day_type_id quedará undefined y el select aparecerá vacío

			// Para reglas de tipo turno, "formula" es un número simple (string) que se usa como multiplicador.
			// Lo extraemos y lo mostramos con coma en el UI.
			// IMPORTANTE: Hacer esto ANTES de procesar reglas calculadas para no perder el valor.
			if (isShiftRuleType(rule.type)) {
				if (rule.formula) {
					// El backend envía solo un número simple como "1.5" (con punto)
					const formulaStr = String(rule.formula).trim();
					// Convertir punto a coma para mostrar en el UI
					rule.coefficient = formulaStr.replace('.', ',');
				} else {
					// Reglas antiguas sin formula: inicializar con "1" por defecto para retrocompatibilidad
					rule.coefficient = rule.coefficient || '1';
				}
			}

			// Procesar fórmulas para reglas calculadas (solo si tiene accounts_in_formula)
			if (rule.formula && rule.accounts_in_formula && rule.accounts_in_formula.length > 0) {
				let formula_pretty = rule.formula;
				let formula_easy = rule.formula;

				rule.accounts_in_formula.forEach((account, index) => {
					const name = account.name.replaceAll(" ", "_");
					var pos = index + 1;
					if (pos < 10)
						pos = "0" + pos;

					formula_pretty = formula_pretty.replaceAll("account_id=" + account.id, name);
					formula_easy = formula_easy.replaceAll("account_id=" + account.id, "A" + pos);
				});
				rule.formula_pretty = formula_pretty;
				rule.formula_easy = formula_easy;
			} else if (isCalculatedRuleType(rule.type)) {
				// Solo limpiar formula para reglas calculadas sin accounts_in_formula
				rule.formula = '';
				rule.formula_pretty = '';
				rule.formula_easy = '';
			}

			if (rule.contracts) {
				selected_contracts = rule.contracts
			}
		}

		this.state = {
			isReadOnly,
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			rule,
			accounts_in_formula: rule.accounts_in_formula || [],
			new_item_errors: {},
			temp_account: {},
			temp_contract: {},
			selected_contracts,
		};
	}

	componentDidMount() {
		// Cargar ubicaciones seleccionables si no están en props
		if (!this.props.select_ubications || this.props.select_ubications.length === 0) {
			if (this.props.getSelectableUbications) {
				this.props.getSelectableUbications();
			}
		}

		// Cargar tipos de día seleccionables si no están en props
		if (!this.props.select_day_types || this.props.select_day_types.length === 0) {
			if (this.props.getSelectableDayTypes) {
				this.props.getSelectableDayTypes();
			}
		}

		// Si estamos editando y tenemos day_type_id pero select_day_types aún no están cargados,
		// esperar a que se carguen para asegurar que el select muestre el valor correcto
		if (this.state.isEdit && this.state.rule.day_type_id && (!this.props.select_day_types || this.props.select_day_types.length === 0)) {
			this.waitForDayTypes = true;
		}
	}

	componentDidUpdate(prevProps) {
		// Si los select_day_types se acaban de cargar y tenemos day_type_id que mostrar
		if (this.waitForDayTypes && this.props.select_day_types && this.props.select_day_types.length > 0) {
			// Verificar que el day_type_id existe en los select_day_types disponibles
			const { rule } = this.state;
			if (rule.day_type_id) {
				const dayTypeExists = this.props.select_day_types.find(item => item.id === parseInt(rule.day_type_id));
				if (!dayTypeExists) {
					// Si el day_type_id no existe en los disponibles, podría ser un problema
					console.warn('day_type_id no encontrado en select_day_types:', rule.day_type_id);
				}
			}
			this.waitForDayTypes = false;
		}
	}

	updateRuleFormulas = (rule, accounts_in_formula, f_easy) => {
		let formula_easy = f_easy ? f_easy : rule.formula_easy;
		let formula_pretty = formula_easy;
		let formula = formula_easy;

		accounts_in_formula.forEach((account, index) => {
			var pos = index + 1;
			if (pos < 10)
				pos = "0" + pos;

			const name = account.name.replaceAll(" ", "_");
			formula_pretty = formula_pretty.replaceAll("A" + pos, name);
			formula = formula.replaceAll("A" + pos, "account_id=" + account.id);

		});

		rule.formula_easy = formula_easy;
		rule.formula_pretty = formula_pretty;
		rule.formula = formula;

		return rule;
	}

	handleChangeFormula = event => {
		const { rule, accounts_in_formula } = this.state;
		let formula_easy = event.target.value;

		this.setState({
			rule: this.updateRuleFormulas(rule, accounts_in_formula, formula_easy.toUpperCase()),
		});
	}

	handleChange = event => {
		const { rule } = this.state;
		let key = event.target.id;
		let value = event.target.value;

		if (key === "is_add" || key === "is_subtract") {
			key = "is_add";
			value = (event.target.id === "is_add");
		}

		if (key === "type" && rule.is_add === undefined) {
			rule.is_add = true;
		}

		this.setState({
			rule: {
				...rule,
				[key]: value
			},
		});
	}

	handleCoefficientChange = (event) => {
		const { rule } = this.state;
		let value = event.target.value;

		// Normalizamos en el UI:
		// - Convertimos puntos en comas.
		// - Eliminamos cualquier carácter que no sea dígito o coma.
		// - Permitimos solo una coma.
		value = value.replace(/\./g, ',');
		// Solo dígitos y comas
		value = value.replace(/[^0-9,]/g, '');
		// Máximo una coma
		const firstCommaIndex = value.indexOf(',');
		if (firstCommaIndex !== -1) {
			const before = value.slice(0, firstCommaIndex + 1);
			const after = value.slice(firstCommaIndex + 1).replace(/,/g, '');
			value = before + after;
		}

		this.setState({
			rule: {
				...rule,
				coefficient: value
			}
		});
	}

	handleAddChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	checkValidField = (name) => {
		return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	prepareRuleToSubmit = (rule) => {
		// si antes teniamos un tipo de tiempo /turno y hemos cambiado, elimina rastro anterior
		if (isTimeTypeRuleType(rule.type)) {
			delete (rule['shift']);
			delete (rule['shift_id']);
			delete (rule['account_type']);
		}
		if (isShiftRuleType(rule.type)) {
			delete (rule['time_type']);
			delete (rule['time_type_id']);
			delete (rule['account_type']);
			delete (rule['ubication']);
			delete (rule['ubication_id']);
		}
		// Horas fichadas: misma idea que turno respecto a campos de planificación
		if (isClockedHoursRuleType(rule.type)) {
			delete (rule['shift']);
			delete (rule['shift_id']);
			delete (rule['account_type']);
			delete (rule['ubication']);
			delete (rule['ubication_id']);
		}
		if (isCalculatedRuleType(rule.type)) {
			delete (rule['shift']);
			delete (rule['shift_id']);
			delete (rule['time_type']);
			delete (rule['time_type_id']);
			delete (rule['is_add']);
			// Para reglas CALCULATED, account_id NO debe estar presente
			delete (rule['account_id']);
			delete (rule['account']);
			delete (rule['ubication']);
			delete (rule['ubication_id']);
			delete (rule['day_type']);
			delete (rule['day_type_id']);
		}

		// Campo solo de UI: no debe enviarse al backend.
		if (rule.coefficient !== undefined) {
			delete (rule['coefficient']);
		}


		if (this.state.selected_contracts.length > 0) {
			const contract_ids = [];

			this.state.selected_contracts.map(c => {
				contract_ids.push(c.id);
				return true;
			});

			rule.contract_ids = contract_ids;
		}

		// Enviar day_type_id (snake_case) al backend solo si está definido y no es vacío
		// Siguiendo el patrón: ubication_id, account_id, etc. Usamos snake_case: day_type_id
		if (this.state.rule.day_type_id && this.state.rule.day_type_id !== '') {
			rule.day_type_id = parseInt(this.state.rule.day_type_id, 10);
		} else {
			// Si no hay day_type_id seleccionado, asegurarse de que no se envíe
			delete (rule['day_type_id']);
			delete (rule['day_type']);
		}

		// Reglas no calculadas: quitar campos de UI / vacíos que pueden romper la deserialización en el API
		if (!isCalculatedRuleType(rule.type)) {
			delete rule.formula_pretty;
			delete rule.formula_easy;
			delete rule.accounts_in_formula;
			if (!rule.start_hour) {
				delete rule.start_hour;
			}
			if (!rule.end_hour) {
				delete rule.end_hour;
			}
			if (rule.formula === '' || rule.formula === null) {
				delete rule.formula;
			}
		}

		if (rule.account_id !== undefined && rule.account_id !== null && rule.account_id !== '') {
			const aid = parseInt(rule.account_id, 10);
			if (!Number.isNaN(aid)) {
				rule.account_id = aid;
			}
		}

		return rule;
	}

	handleSubmit = async event => {
		event.preventDefault();
		this.setState({ isLoading: true });

		let response = '';
		const props = this.props;
		const { rule } = this.state;

		// Validación del coeficiente para reglas de turno (0–100, máx. 2 decimales).
		const errors = {};
		let hasLocalError = false;
		let normalizedCoefficient = null;

		// Validar account_id para reglas de tipo "Tipo de tiempo" y "Turno"
		// Para "CALCULATED", account_id NO debe estar presente
		if (isCalculatedRuleType(rule.type)) {
			if (rule.account_id) {
				errors.account_id = this.props.t('rules.form.calculatedNoAccount');
				hasLocalError = true;
			}
		} else if (isTimeTypeRuleType(rule.type) || isShiftRuleType(rule.type)) {
			if (!rule.account_id || rule.account_id === '') {
				errors.account_id = this.props.t('rules.form.accountRequired');
				hasLocalError = true;
			}
		}

		// Validar time_type_id para reglas de tipo "Tipo de tiempo"
		if (isTimeTypeRuleType(rule.type)) {
			if (!rule.time_type_id || rule.time_type_id === '') {
				errors.time_type_id = this.props.t('rules.form.timeTypeRequired');
				hasLocalError = true;
			}
		}

		if (isShiftRuleType(rule.type)) {
			// Si el coeficiente está vacío, usar "1" por defecto para retrocompatibilidad con reglas antiguas
			let raw = (rule.coefficient !== undefined && rule.coefficient !== null)
				? String(rule.coefficient).trim()
				: '';

			// Si está vacío, usar "1" por defecto (retrocompatibilidad)
			if (!raw) {
				raw = '1';
			}

			if (!raw) {
				errors.coefficient = this.props.t('rules.form.valueRequired');
				hasLocalError = true;
			} else {
				const normalized = normalizeDecimal(raw);
				const numberValue = Number(normalized);

				if (Number.isNaN(numberValue)) {
					errors.coefficient = this.props.t('rules.form.invalidNumber');
					hasLocalError = true;
				} else if (numberValue < 0 || numberValue > 100) {
					errors.coefficient = this.props.t('rules.form.valueRange');
					hasLocalError = true;
				} else if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
					errors.coefficient = this.props.t('rules.form.maxDecimals');
					hasLocalError = true;
				} else {
					normalizedCoefficient = normalized;
				}
			}
		}

		if (hasLocalError) {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: {
					...this.state.errors,
					...errors,
				},
			});
			return;
		}

		let copiedRule = Object.assign({}, rule);

		// Para reglas de turno, enviamos el coeficiente como string con punto decimal.
		// Si el coeficiente es "1" (valor por defecto), no enviamos formula para optimizar.
		// Si no hay coeficiente, no enviamos formula o lo enviamos como null.
		// Para reglas "Calculated", la fórmula se construye en updateRuleFormulas con account_id=X.
		if (isShiftRuleType(rule.type)) {
			if (normalizedCoefficient !== null && normalizedCoefficient !== "1") {
				// Solo enviar formula si el coeficiente es diferente de "1"
				copiedRule.formula = normalizedCoefficient; // String con punto, ej: "1.5"
			} else {
				// Si el coeficiente es "1" o no hay coeficiente, no enviar formula
				// (el backend usará el valor por defecto)
				copiedRule.formula = null;
			}
		}

		const rule_temp = this.prepareRuleToSubmit(copiedRule);

		if (rule_temp.start_hour) {
			rule_temp.start_hour = convertToUTC(rule_temp.start_hour);
		}

		if (rule_temp.end_hour) {
			rule_temp.end_hour = convertToUTC(rule_temp.end_hour);
		}

		// if edit => update; else => new
		try {
			if (this.state.isEdit) {
				response = await rulesService.update(rule_temp);
			} else {
				response = await rulesService.add(rule_temp);
			}
		} catch (err) {
			console.error('rulesService add/update', err);
			this.setState({ isLoading: false, submitted: true });
			toastr.error(
				this.props.t('rules.networkError'),
				this.props.t('rules.networkErrorMsg')
			);
			return;
		}

		//console.log(response);
		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			}, () => {

				toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
				this.props.getAllRules();
				props.handleClose();

			});
		}
		else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response)
			});
		}
	}

	// accounts being used in formula
	addAccount = () => {
		let { accounts_in_formula, temp_account, rule } = this.state;
		let isValid = true;
		let account;
		const new_item_errors = {};

		if (temp_account === undefined) {
			isValid = false;
		}
		else {
			account = this.props.select_accounts.find(item => item.id === parseInt(temp_account));
			if (account === undefined) {
				isValid = false;
				new_item_errors.account = false;
			}
		}

		if (isValid) {
			// check if account already exists
			const exists = accounts_in_formula.find(item => item.id === parseInt(temp_account));

			// if not : add new account
			if (!exists) {
				accounts_in_formula = accounts_in_formula.concat(account);
			}

			this.setState({
				accounts_in_formula,
				new_item_errors: {},
				temp_account: {},
				rule: this.updateRuleFormulas(rule, accounts_in_formula),
			});
		}
		else {
			this.setState({
				new_item_errors,
			});
		}
	}

	removeAccount = (idAccount) => {
		let { accounts_in_formula, rule } = this.state;
		accounts_in_formula = accounts_in_formula.filter(item => item.id !== parseInt(idAccount));

		this.setState({
			accounts_in_formula,
			rule: this.updateRuleFormulas(rule, accounts_in_formula),
		});
	}

	// layout:
	getSelectedAccounts = () => this.state.accounts_in_formula.map((item, index) => {
		var pos = index + 1;

		if (pos < 10)
			pos = "0" + pos;

		return (
			<li key={item.id} className="tag-default tag-delete">
				A{pos} : {item.name}
				<button type="button" onClick={() => this.removeAccount(item.id)} className="btn-tag-delete btn-transparent"><FiX /></button>
			</li>
		)
	});


	// reglas de contratos

	getSelectedContracts = () => this.state.selected_contracts.map((item) => {
		return (
			<li key={item.id} className="tag-default tag-delete" style={{ backgroundColor: item.background_color && item.background_color }}>
				{item.name}
				<button type="button" onClick={() => this.removeContract(item.id)} className="btn-tag-delete btn-transparent"><FiX /></button>
			</li>
		)
	});

	addContract = () => {
		let { selected_contracts, temp_contract } = this.state;
		let isValid = true;
		let contract;
		const new_item_errors = {};

		if (temp_contract === undefined) {
			isValid = false;
		}
		else {
			contract = this.props.contracts.find(item => item.id === parseInt(temp_contract));
			if (contract === undefined) {
				isValid = false;
				new_item_errors.contract = false;
			}
		}

		if (isValid) {
			// check if day already exists
			const exists = selected_contracts.find(item => item.id === parseInt(temp_contract));

			if (!exists) {
				selected_contracts = selected_contracts.concat(contract);
			}

			this.setState({
				selected_contracts,
				new_item_errors: {},
				temp_contract: {},
			});
		}
		else {
			this.setState({
				new_item_errors,
			});
		}
	}
	removeContract = (idContract) => {
		this.setState((prevState, props) => {
			return {
				selected_contracts: prevState.selected_contracts.filter(item => item.id !== parseInt(idContract))
			};
		});
	}


	render() {
		const { isReadOnly, rule, errors, new_item_errors, temp_account, temp_contract, accounts_in_formula } = this.state;
		const { select_accounts, select_shifts, select_time_types, rule_types, account_types, contracts, select_day_types } = this.props;
		const is_add = rule.is_add;

		const optionAccountList = select_accounts.length > 0 && select_accounts.map((item, i) => {
			return <option key={i} value={item.id}>{item.name}</option>
		}, this);

		const optionRuleTypesList = rule_types.length > 0 && rule_types.map((item, i) => {
			return <option key={i} value={item.name}>{item.name}</option>
		}, this);

		const optionShiftsList = select_shifts.length > 0 && select_shifts.map((item, i) => {
			return <option key={i} value={item.id}>{item.name} {getFirstLastInterval(item.time_intervals, true)}</option>
		}, this);

		const optionTimeTypesList = select_time_types.length > 0 && select_time_types.map((item, i) => {
			return <option key={i} value={item.id}>{item.name}</option>
		}, this);

		const optionAccountTypesList = account_types.length > 0 && account_types.map((item, i) => {
			return <option key={i} value={item.id}>{item.name}</option>
		}, this);

		const isContractRule = isContractRuleType(rule.type, rule_types);

		const optionContractList = contracts.length > 0 && contracts.map((item, i) => {
			return <option key={i} value={item.id}>{item.name}</option>
		}, this);

		const optionUbicationsList = (this.props.select_ubications && this.props.select_ubications.length > 0) && this.props.select_ubications.map((item, i) => {
			return <option key={i} value={item.id}>{item.name}</option>
		}, this);

		const optionDayTypeList = (select_day_types && select_day_types.length > 0) && select_day_types.map((item, i) => {
			const label = item.description ? (item.name + " (" + item.description + ")") : item.name;
			return (
				<option key={i} value={item.id}>{label}</option>
			)
		}, this);

		const showDayTypeFilter = supportsDayTypeFilter(rule.type, rule_types);

		return (
			<form className="modal-rule" >
				<div className="modal-body">

					<FormGroup className="form-group" controlId="name">
						<FormLabel>{this.props.t('common.name')} <span className="label-required">*</span></FormLabel>
						<FormControl
							type="text"
							value={rule.name}
							onChange={this.handleChange}
							placeholder={this.props.t('rules.form.namePlaceholder')}
							isInvalid={this.checkValidField('name')}
							disabled={isReadOnly}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.name}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup className="form-group" controlId="description">
						<FormLabel>{this.props.t('common.description')}</FormLabel>
						<FormControl
							type="text"
							value={rule.description}
							onChange={this.handleChange}
							placeholder={this.props.t('rules.form.descriptionPlaceholder')}
							isInvalid={this.checkValidField('description')}
							disabled={isReadOnly}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.description}
						</FormControl.Feedback>
					</FormGroup>

					<Row>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="type">
								<FormLabel>{this.props.t('rules.form.transactionType')} <span className="label-required">*</span></FormLabel>
								<FormControl
									value={rule.type}
									onChange={this.handleChange}
									placeholder={this.props.t('rules.form.transactionType')}
									isInvalid={this.checkValidField('type')}
									as="select"
									disabled={isReadOnly}
								>
									<option value="">{this.props.t('rules.form.selectType')}</option>
									{optionRuleTypesList}
								</FormControl>

								<FormControl.Feedback type="invalid">
									{errors.type}
								</FormControl.Feedback>
							</FormGroup>
						</Col>

						<Col sm={6}>
							{(isTimeTypeRuleType(rule.type, rule_types) || isClockedHoursRuleType(rule.type, rule_types)) &&
								(<FormGroup className="form-group" controlId="time_type_id">
									<FormLabel>
										{this.props.t('rules.form.timeType')}
										{isTimeTypeRuleType(rule.type, rule_types) && <span className="label-required"> *</span>}
									</FormLabel>
									<FormControl
										value={rule.time_type_id || ''}
										onChange={this.handleChange}
										placeholder={this.props.t('rules.form.timeType')}
										isInvalid={this.checkValidField('time_type_id')}
										as="select"
										disabled={isReadOnly}
									>
										<option value="">{this.props.t('rules.form.selectTimeType')}</option>
										{optionTimeTypesList}
									</FormControl>

									<FormControl.Feedback type="invalid">
										{errors.time_type_id}
									</FormControl.Feedback>
								</FormGroup>)
							}
							{isShiftRuleType(rule.type, rule_types) &&
								(<FormGroup className="form-group" controlId="shift_id">
									<FormLabel>{this.props.t('rules.form.shift')}</FormLabel>
									<FormControl
										value={rule.shift_id}
										onChange={this.handleChange}
										placeholder={this.props.t('rules.form.shift')}
										isInvalid={this.checkValidField('shift_id')}
										as="select"
										disabled={isReadOnly}
									>
										<option value="">{this.props.t('rules.form.selectShift')}</option>
										{optionShiftsList}
									</FormControl>
									<FormControl.Feedback type="invalid">
										{errors.shift_id}
									</FormControl.Feedback>
								</FormGroup>)
							}
							{isCalculatedRuleType(rule.type, rule_types) &&
								(<FormGroup className="form-group" controlId="account_type">
									<FormLabel>{this.props.t('rules.form.accountType')}</FormLabel>
									<FormControl
										value={rule.account_type}
										onChange={this.handleChange}
										placeholder={this.props.t('rules.form.accountType')}
										isInvalid={this.checkValidField('account_type')}
										as="select"
										disabled={isReadOnly}
									>
										<option value="">{this.props.t('rules.form.selectAccountType')}</option>
										{optionAccountTypesList}
									</FormControl>
									<FormControl.Feedback type="invalid">
										{errors.account_type}
									</FormControl.Feedback>
								</FormGroup>)
							}
						</Col>
					</Row>

					{isTimeTypeRuleType(rule.type, rule_types) &&
						<Row>
							<Col sm={6}>
								<FormGroup controlId="start_hour" className="form-group form-group-time">
									<FormLabel>{this.props.t('rules.form.startHour')}</FormLabel>
									<TimeInputWithArrows
										id="start_hour"
										value={rule.start_hour || ''}
										onChange={this.handleChange}
										isInvalid={this.checkValidField('start_hour')}
										disabled={isReadOnly}
										placeholder="HH:mm"
										nextInputId="end_hour"
									/>

									<FormControl.Feedback type="invalid">
										{errors.start_hour}
									</FormControl.Feedback>
								</FormGroup>
							</Col>

							<Col sm={6}>
								<FormGroup controlId="end_hour" className="form-group form-group-time">
									<FormLabel>{this.props.t('rules.form.endHour')}</FormLabel>
									<TimeInputWithArrows
										id="end_hour"
										value={rule.end_hour || ''}
										onChange={this.handleChange}
										disabled={isReadOnly}
										isInvalid={this.checkValidField('end_hour')}
										placeholder="HH:mm"
									/>

									<FormControl.Feedback type="invalid">
										{errors.end_hour}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						</Row>
					}

					{!isCalculatedRuleType(rule.type, rule_types) &&
						<Row>
							<Col sm={4}>
								<FormGroup className="form-group" controlId="type">
									<FormLabel>{this.props.t('rules.form.operationType')}</FormLabel>
									<div className={`btn-choice-group ${isReadOnly && 'disabled'} `}>
										<FormCheck
											type="radio"
											id="is_add"
											label={this.props.t('rules.sum')}
											value="true"
											checked={is_add}
											bsPrefix={is_add ? 'btn-choice active' : 'btn-choice'}
											onChange={this.handleChange}
											disabled={isReadOnly}
										/>
										<FormCheck
											type="radio"
											id="is_subtract"
											label={this.props.t('rules.subtract')}
											value="false"
											checked={!is_add}
											bsPrefix={!is_add ? 'btn-choice active' : 'btn-choice'}
											onChange={this.handleChange}
											disabled={isReadOnly}
										/>
									</div>
								</FormGroup>
							</Col>

							{isShiftRuleType(rule.type, rule_types) &&
								<Col sm={2}>
									<FormGroup className="form-group" controlId="coefficient">
										<FormLabel>{this.props.t('rules.form.value')} <span className="label-required">*</span></FormLabel>
										<FormControl
											type="text"
											value={rule.coefficient || ''}
											onChange={this.handleCoefficientChange}
											placeholder={this.props.t('rules.form.valuePlaceholder')}
											isInvalid={this.checkValidField('coefficient')}
											disabled={isReadOnly}
										/>

										<FormControl.Feedback type="invalid">
											{this.state.errors.coefficient}
										</FormControl.Feedback>
									</FormGroup>
								</Col>
							}

							<Col sm={isShiftRuleType(rule.type, rule_types) ? 6 : 8}>
								<FormGroup className="form-group" controlId="account_id">
									<FormLabel>{this.props.t('rules.form.targetAccount')} <span className="label-required">*</span></FormLabel>
									<FormControl
										value={rule.account_id || ''}
										onChange={this.handleChange}
										placeholder={this.props.t('rules.form.selectAccount')}
										isInvalid={this.checkValidField('account_id')}
										as="select"
										disabled={isReadOnly}
									>
										<option value="">Selecciona cuenta</option>
										{optionAccountList}
									</FormControl>

									<FormControl.Feedback type="invalid">
										{errors.account_id}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						</Row>
					}


					{isCalculatedRuleType(rule.type, rule_types) &&
						<>
							{!isReadOnly &&
								<>
									<h3 className="subtitle">{this.props.t('rules.form.calculatedConfig')}</h3>
									<p className="text-info">{this.props.t('rules.form.calculatedInfo')}</p>

									<div className="flex-group mb10">
										<FormGroup className="form-group" controlId="temp_account">
											<FormControl
												type="text"
												onChange={this.handleAddChange}
												value={temp_account}
												placeholder={this.props.t('rules.form.selectAccount')}
												isInvalid={new_item_errors.account !== undefined}
												as="select"
											>
												<option value="">{this.props.t('rules.form.selectAccount')}</option>
												{optionAccountList}
											</FormControl>
										</FormGroup>
										<button type="button" onClick={this.addAccount} className="btn btn-primary">{this.props.t('common.add')}</button>
									</div>
									<ul className="list-tags">
										{this.getSelectedAccounts()}
									</ul>
								</>
							}

							{accounts_in_formula.length > 0 ?
								(<>
									<FormGroup className="form-group" controlId="formula_easy">
										<FormLabel>{this.props.t('rules.form.formulaLabel')}</FormLabel>
										{!isReadOnly &&
											<>
												<p className="text-info">{this.props.t('rules.form.calculatedInfo')}</p>

												<FormControl
													value={rule.formula_easy}
													onChange={this.handleChangeFormula}
													placeholder={this.props.t('rules.form.formulaPlaceholder')}
													isInvalid={this.checkValidField('formula')}
													disabled={isReadOnly}
												/>
											</>
										}

										<FormControl.Feedback type="invalid">
											{errors.formula}
										</FormControl.Feedback>
									</FormGroup>

									<p className="text-info text-info-pretty">{rule.formula_pretty}</p>
									<p className="text-info hidden">{rule.formula}</p>
								</>)
								:
								(errors.formula && <p className="invalid-feedback d-block">{errors.formula}</p>)
							}

						</>
					}

					{isContractRule && (
						<div
							className="form-group mb20"
						>
							<p className="mb5 label">{this.props.t('rules.form.applyContracts')}</p>

							<div className="flex-group mb10">
								<FormGroup className="form-group" controlId="temp_contract">
									<FormControl
										type="text"
										value={temp_contract}
										placeholder={this.props.t('rules.form.selectContract')}
										onChange={this.handleAddChange}
										isInvalid={new_item_errors.contract !== undefined}
										as="select"
									>
										<option value="">{this.props.t('rules.form.selectContract')}</option>
										{optionContractList}
									</FormControl>
								</FormGroup>
								<button type="button" onClick={this.addContract} className="btn btn-primary">{this.props.t('common.add')}</button>
							</div>
							<ul className="list-tags">
								{this.getSelectedContracts()}
							</ul>
						</div>
					)}

					{isTimeTypeRuleType(rule.type, rule_types) && (
						<FormGroup className="form-group" controlId="ubication_id">
							<FormLabel>{this.props.t('rules.form.applyLocation')}</FormLabel>
							<FormControl
								value={rule.ubication_id || ''}
								onChange={this.handleChange}
								placeholder={this.props.t('rules.form.selectLocation')}
								as="select"
								disabled={isReadOnly}
							>
								<option value="">{this.props.t('rules.form.selectLocation')}</option>
								{optionUbicationsList}
							</FormControl>
						</FormGroup>
					)}

					{showDayTypeFilter && (
						<FormGroup className="form-group" controlId="day_type_id">
							<FormLabel>{this.props.t('rules.form.applyDayType')}</FormLabel>
							<FormControl
								value={rule.day_type_id || ''}
								onChange={this.handleChange}
								placeholder={this.props.t('rules.form.selectDayType')}
								isInvalid={this.checkValidField('day_type_id')}
								as="select"
								disabled={isReadOnly}
							>
								<option value="">{this.props.t('rules.form.selectDayType')}</option>
								{optionDayTypeList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{errors.day_type_id}
							</FormControl.Feedback>
						</FormGroup>
					)}
				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
					{!isReadOnly && (
						<SubmitButton
							type="button"
							isLoading={this.state.isLoading}
							text={this.props.t('common.save')}
							loadingText={this.props.t('common.saving')}
							onClick={this.handleSubmit}
						/>
					)}
				</div>
			</form>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.rulesReducer,
		...reducers.timesReducer,
		...reducers.shiftsReducer,
		...reducers.ubicationsReducer,
		...reducers.calendarsReducer,
		loading: reducers.rulesReducer.loading
	}
};
export default connect(mapStateToProps, { ...rulesActions, ...ubicationsActions, ...calendarsActions })(withTranslation()(RuleEdit))
